import { useDisclosure } from '../../../../hooks';

export const useModalDisclosures = () => {
    const { isOpen: isCancelTicketOpen, onOpen: onCancelTicketOpen, onClose: onCancelTicketClose } = useDisclosure();
    const {
        isOpen: isCancelTicketReasonOpen,
        onOpen: onCancelTicketReasonOpen,
        onClose: onCancelTicketReasonClose,
    } = useDisclosure();

    const {
        isOpen: isReassignTicketOpen,
        onOpen: onReassignTicketOpen,
        onClose: onReassignTicketClose,
    } = useDisclosure();

    const {
        isOpen: isBulkReassignTicketOpen,
        onOpen: onBulkReassignTicketOpen,
        onClose: onBulkReassignTicketClose,
    } = useDisclosure();

    const { isOpen: isReopenTicketOpen, onOpen: onReopenTicketOpen, onClose: onReopenTicketClose } = useDisclosure();

    const {
        isOpen: isCompleteTicketOpen,
        onOpen: onCompleteTicketOpen,
        onClose: onCompleteTicketClose,
    } = useDisclosure();

    const {
        isOpen: isCompleteVerifyTicketOpen,
        onOpen: onCompleteVerifyTicketOpen,
        onClose: onCompleteVerifyTicketClose,
    } = useDisclosure();

    const {
        isOpen: isExportTicketsOpen,
        onOpen: onExportTicketsOpen,
        onClose: onExportTicketsClose,
    } = useDisclosure();

    return {
        isCancelTicketOpen,
        isCancelTicketReasonOpen,
        onCancelTicketOpen,
        onCancelTicketReasonOpen,
        onCancelTicketClose,
        onCancelTicketReasonClose,
        isCompleteVerifyTicketOpen,
        onCompleteTicketOpen,
        onCompleteVerifyTicketOpen,
        onCompleteVerifyTicketClose,
        isCompleteTicketOpen,
        onCompleteTicketClose,
        isReassignTicketOpen,
        onReassignTicketOpen,
        onReassignTicketClose,
        onReopenTicketOpen,
        isReopenTicketOpen,
        onReopenTicketClose,
        isBulkReassignTicketOpen,
        onBulkReassignTicketOpen,
        onBulkReassignTicketClose,
        isExportTicketsOpen,
        onExportTicketsOpen,
        onExportTicketsClose,
    };
};
